import { motion } from "framer-motion";
import styled from "styled-components";

export const StyledContainer = styled.div`
  height: 100%;
  max-height: 100dvh;
  width: 100%;
  min-width: 1264px;
  max-width: 1250px;
  margin-inline: auto;
  display: grid;
  grid-template-columns: repeat(16, 1fr);
  /* overflow: hidden; */
  gap: 32px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
    min-width: auto;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    grid-template-columns: unset;
    display: flex;
    flex-direction: column;
    max-width: none;
    height: auto;
    max-height: none;
    overflow-y: visible;
    padding: 0;
    gap: 0;
  }
`;

// export const StyledSidebar = styled(Sidebar)`
//   grid-column: 2 / 6;
//   @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
//     grid-column: 2 / 7;
//   }
//   @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
//     grid-column: unset;
//     padding-inline: 24px;
//     max-height: none;
//     overflow: unset;
//   }
// `;

export const Wrapper = styled.div`
  width: 100%;
  height: 100dvh;
  position: relative;
  grid-column: 8 / 16;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    max-width: none;
    height: auto;
    max-height: none;
  }

  &.detail,
  &.billing,
  &.error {
    grid-column: 3 / 15;
    @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
      grid-column: 2 / 16;
    }
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
      grid-column: unset;
      padding-inline: 24px;
    }
  }
`;

export const AnimatedWrapper = styled(motion.div)`
  width: 100%;
  height: 100dvh;
  position: relative;
  grid-column: 8 / 16;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    max-width: none;
    height: auto;
    max-height: none;
  }

  &.detail,
  &.billing,
  &.error {
    grid-column: 3 / 15;
    @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
      grid-column: 2 / 16;
    }
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
      grid-column: unset;
      padding-inline: 24px;
    }
  }
`;

export const NavContent = styled.div`
  --padding: 16px;
  padding-inline: var(--padding);
  padding-block: var(--padding);
  position: absolute;
  top: var(--padding);
  left: calc(-1 * var(--padding));
  right: calc(-1 * var(--padding));
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: transparent;
  backdrop-filter: blur(4px);
  border-radius: 5px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    margin-bottom: 0;
  }
`;

export const InnerContent = styled.div`
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding-block: 106px 64px;
  max-height: 100dvh;
  height: 100dvh;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    padding-block: 0 32px;
    height: auto;
    max-height: none;
    overflow: unset;
  }

  &.inner-content {
    &.detail,
    &.billing,
    &.error {
      padding-block: 180px 32px;
      @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
        padding-block: 32px;
      }
    }
    &.billing {
      padding-block: 140px 32px;
      @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
        padding-block: 32px;
      }
    }
    &.error {
      padding: 0;
      height: 100dvh;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const DetailNav = styled.div`
  position: absolute;
  top: 24px;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  z-index: 999;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    position: relative;
    top: unset;
    right: unset;
    left: unset;
    flex-direction: column-reverse;
    align-items: flex-end;
    gap: 20px;
    padding-block: 24px 32px;

    &.billing-section {
      flex-direction: column;
    }
  }

  &.billing-section {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    grid-column-gap: 32px;
    width: 100%;
    margin: 0 auto;

    .billing-artist-info-detail {
      grid-column: 1 / 5;
    }

    .billing-nav {
      grid-column: 7 / 13;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.laptopS}px`}) {
      grid-template-columns: unset;
      grid-template-rows: unset;
      grid-column-gap: unset;

      display: flex;
      flex-direction: column;
      gap: 32px;

      .billing-artist-info-detail,
      .billing-nav {
        grid-column: unset;
      }
    }
  }
`;
